import { SesMessageCoreBase } from "./ses-message.core.base"


export class SesMessageCore extends SesMessageCoreBase {

}